import { isEmpty, uniqueId } from 'lodash'
import { motion } from 'framer-motion'
import { getImageUrl } from './getImageUrl'
import { getValue } from '../functions'
import { motionStyles } from '../styles'

export const renderColumns = ({ columns, rowDelay, isInView = false, loading }) => {
  if (isEmpty(columns)) return null

  return columns?.map((column, index) => {
    const columnKey = uniqueId()

    const columnDelay = rowDelay + index * 0.3

    const animate = isInView && !loading ? motionStyles.animate : {}

    if (column?.its_an_image)
      return (
        <motion.img
          key={columnKey}
          className="my-[14px] xl:my-0 xl:min-w-[500px] h-[66px] lg:h-[100px] 2xl:h-[114px] rounded-pill bg-cover"
          src={getImageUrl(column)}
          alt={getValue(column?.alt)}
          title={getValue(column?.title)}
          description={getValue(column?.description)}
          caption={getValue(column?.caption)}
          author={getValue(column?.author)}
          initial={motionStyles.initial}
          animate={animate}
          transition={{
            ...motionStyles.transition,
            delay: columnDelay,
            ease: [0.79, 0.14, 0.15, 0.86],
          }}
        />
      )

    return (
      <motion.span
        key={columnKey}
        className="text-nowrap leading-none"
        initial={motionStyles.initial}
        animate={animate}
        transition={{
          ...motionStyles.transition,
          delay: columnDelay,
          ease: [0.79, 0.14, 0.15, 0.86],
        }}
      >
        {column?.text}
      </motion.span>
    )
  })
}
